/* One space, and it is a brand rule rather than a preference.

   futuratrailers.com prints deck dimensions as 19' 8", with a space between
   the feet and the inches. The parts store prints 19'8". Same company, same
   measurement, two notations, and the parts store is the one that is wrong.

   It is done here rather than in the stylesheet because CSS cannot insert a
   character, and here rather than in the extension because the extension is
   not ours to change today.

   IT IS IDEMPOTENT BY CONSTRUCTION. The pattern requires a digit immediately
   after the apostrophe, so a value that already carries the space no longer
   matches and the second pass finds nothing. That matters because the
   observer below fires on this script's own writes. */
(function () {
  var TARGETS = '.ident-preview-dims b, .ident-card-dims b, .ident-kv-row dd, .ident-dims .is-key';
  var FEET_INCH = /(\d)'(\d)/g;
  var queued = null;

  function fix(node) {
    var text = node.textContent;
    if (!text || text.indexOf("'") === -1) return;
    var next = text.replace(FEET_INCH, "$1' $2");
    if (next !== text) node.textContent = next;
  }

  function pass() {
    queued = null;
    var list = document.querySelectorAll(TARGETS);
    for (var i = 0; i < list.length; i++) fix(list[i]);
  }

  function schedule() {
    if (queued) return;
    queued = window.setTimeout(pass, 60);
  }

  function boot() {
    pass();
    if (!window.MutationObserver) return;
    new window.MutationObserver(schedule).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
